import React, { useState } from "react";
import "./LandmarkDropDown.css";
function LandMarkDropdown({
  landmarklist,
  selectedOptions,
  setSelectedOptions,
}) {
  const [isLandmarkOpen, setLandmarkOpen] = useState(false);

  const handleOptionClick = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleRemoveSelectedItem = (event, option) => {
    event.stopPropagation();
    setSelectedOptions(selectedOptions.filter((item) => item !== option));
  };

  return (
    <div className="w-full lg:relative font-jt">
      <div className="w-full p-1 flex flex-row shadow-2xl lg:shadow-none bg-white text-black bg-none lg:border-[2px] rounded-full  items-center justify-between">
        <div className="w-[5%] lg:w-[8%] pl-2">
          <svg
            width="10"
            height="20"
            viewBox="0 0 17 25"
            fill="none"
            className="lg:hidden block"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.4998 0.125C4.25234 0.125 0.810547 3.58613 0.810547 7.85938C0.810547 15.2457 8.4998 24.875 8.4998 24.875C8.4998 24.875 16.1891 15.2457 16.1891 7.85938C16.1891 3.58613 12.7473 0.125 8.4998 0.125ZM8.4998 11.6105C6.48887 11.6105 4.86465 9.97344 4.86465 7.95605C4.86465 5.93867 6.49531 4.29512 8.4998 4.29512C10.5107 4.29512 12.135 5.93223 12.135 7.95605C12.135 9.97344 10.5107 11.6105 8.4998 11.6105Z"
              fill="black"
            />
          </svg>
          <svg
            width="17"
            height="25"
            viewBox="0 0 17 25"
            fill="none"
            className="hidden lg:block"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.4998 0.125C4.25234 0.125 0.810547 3.58613 0.810547 7.85938C0.810547 15.2457 8.4998 24.875 8.4998 24.875C8.4998 24.875 16.1891 15.2457 16.1891 7.85938C16.1891 3.58613 12.7473 0.125 8.4998 0.125ZM8.4998 11.6105C6.48887 11.6105 4.86465 9.97344 4.86465 7.95605C4.86465 5.93867 6.49531 4.29512 8.4998 4.29512C10.5107 4.29512 12.135 5.93223 12.135 7.95605C12.135 9.97344 10.5107 11.6105 8.4998 11.6105Z"
              fill="black"
            />
          </svg>
        </div>

        <div className="w-[95%] lg:w-[92%]">
          <button
            className="w-full py-2 px-2 lg:px-4 text-black  flex flex-row items-center justify-between"
            onClick={() => {
              setLandmarkOpen(!isLandmarkOpen);
            }}
          >
            {selectedOptions.length === 0 ? (
              <>
              <span className="font-semibold text-sm lg:text-base text-center w-full  hidden lg:block">
                Select Landmarks
              </span>
              <span className="font-semibold text-sm lg:text-base text-center w-full  lg:hidden block">
                Landmarks
              </span>
              </>
            ) : (
              <>
              <div className="lg:hidden text-sm font-semibold ml-2 flex flex-wrap">
                Landmarks
              </div>
              <div className="lg:flex hidden flex-wrap">
                {selectedOptions.slice(0, 2).map((optionId) => {
                  const option = landmarklist.find(
                    (item) => item.id === optionId
                  );
                  return (
                    <span
                      key={option.id}
                      className="bg-[#EAEAEA] rounded-full py-1 px-3 mx-1  inline-flex items-center text-base"
                    >
                      {option.title}
                      <button
                        className="ml-2 scale-[1.5] transition-all hover:scale-[2] focus:ring-0 hover:focus:outline-none text-gray-500 hover:text-gray-600 focus:outline-none"
                        onClick={(event) =>
                          handleRemoveSelectedItem(event, option.id)
                        }
                      >
                        &times;
                      </button>
                    </span>
                  );
                })}
                {selectedOptions.length > 2 && (
                  <span className="bg-[#EAEAEA] rounded-full py-1 px-3   inline-flex items-center text-sm">
                    ..
                  </span>
                )}
              </div>
              </>
            )}
            <svg
              width="20"
              height="13"
              viewBox="0 0 23 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      </div>

      {isLandmarkOpen && (
        <>
        <div className="hidden lg:block  lg:absolute w-[100vw] lg:w-[92%]  lg:mt-1 lg:ml-4 custom-scrollbar bg-white rounded-md shadow-lg border-2 border-[#F4F4F4] p-1 lg:max-h-[250px] overflow-y-auto">
          {landmarklist.map((option) => (
            <div
              key={option.id}
              className="px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => handleOptionClick(option.id)}
            >
              <input
                type="checkbox"
                className="mr-2 cursor-pointer accent-black"
                checked={selectedOptions.includes(option.id)}
                onChange={() => handleOptionClick(option.id)}
              />
              <span className="select-none text-lg">{option.title}</span>
            </div>
          ))}
          
        </div>
        <div className="lg:hidden fixed inset-0 top    w-[100vw] lg:w-[92%]  lg:mt-1 lg:ml-4 custom-scrollbar bg-white rounded-md shadow-lg border-2 border-[#F4F4F4] p-1 h-screen lg:h-auto lg:max-h-[250px] overflow-y-auto">
          <div className="text-end mr-2 mt-2"><button  onClick={()=>setLandmarkOpen(!isLandmarkOpen)}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0001 1.41666C13.918 1.41666 10.9051 2.3306 8.34245 4.04292C5.77979 5.75524 3.78243 8.18902 2.60297 11.0365C1.4235 13.884 1.1149 17.0173 1.71618 20.0401C2.31747 23.063 3.80164 25.8397 5.98101 28.0191C8.16038 30.1984 10.9371 31.6826 13.9599 32.2839C16.9828 32.8852 20.1161 32.5766 22.9636 31.3971C25.8111 30.2176 28.2448 28.2203 29.9572 25.6576C31.6695 23.095 32.5834 20.0821 32.5834 17C32.5834 12.867 30.9416 8.90335 28.0192 5.98091C25.0967 3.05847 21.133 1.41666 17.0001 1.41666ZM23.6683 21.6651C23.8036 21.7958 23.9116 21.9521 23.9858 22.1249C24.0601 22.2978 24.0991 22.4837 24.1008 22.6718C24.1024 22.8599 24.0666 23.0464 23.9953 23.2205C23.9241 23.3946 23.8189 23.5528 23.6859 23.6858C23.5529 23.8188 23.3947 23.924 23.2206 23.9952C23.0465 24.0665 22.86 24.1023 22.6719 24.1007C22.4837 24.099 22.2979 24.06 22.125 23.9857C21.9522 23.9115 21.7959 23.8035 21.6652 23.6682L17.0001 19.0032L12.335 23.6682C12.2043 23.8035 12.048 23.9115 11.8752 23.9857C11.7023 24.06 11.5164 24.099 11.3283 24.1007C11.1402 24.1023 10.9537 24.0665 10.7796 23.9952C10.6055 23.924 10.4473 23.8188 10.3143 23.6858C10.1813 23.5528 10.0761 23.3946 10.0048 23.2205C9.93361 23.0464 9.89777 22.8599 9.8994 22.6718C9.90103 22.4837 9.94011 22.2978 10.0144 22.1249C10.0886 21.9521 10.1965 21.7958 10.3318 21.6651L14.9969 17L10.3318 12.3349C10.1965 12.2042 10.0886 12.0479 10.0144 11.8751C9.94011 11.7022 9.90103 11.5163 9.8994 11.3282C9.89777 11.1401 9.93361 10.9536 10.0048 10.7795C10.0761 10.6054 10.1813 10.4472 10.3143 10.3142C10.4473 10.1812 10.6055 10.076 10.7796 10.0047C10.9537 9.93351 11.1402 9.89767 11.3283 9.8993C11.5164 9.90094 11.7023 9.94002 11.8752 10.0143C12.048 10.0885 12.2043 10.1964 12.335 10.3317L17.0001 14.9968L21.6652 10.3317C21.7959 10.1964 21.9522 10.0885 22.125 10.0143C22.2979 9.94002 22.4837 9.90094 22.6719 9.8993C22.86 9.89767 23.0465 9.93351 23.2206 10.0047C23.3947 10.076 23.5529 10.1812 23.6859 10.3142C23.8189 10.4472 23.9241 10.6054 23.9953 10.7795C24.0666 10.9536 24.1024 11.1401 24.1008 11.3282C24.0991 11.5163 24.0601 11.7022 23.9858 11.8751C23.9116 12.0479 23.8036 12.2042 23.6683 12.3349L19.0033 17L23.6683 21.6651Z"
                fill="#D00808"
              />
            </svg>
          </button></div>

          <div className="text-center text-4xl font-semibold mb-5">Select landmarks</div>
          <div className="flex  justify-end">
            <button onClick={()=>setLandmarkOpen(!isLandmarkOpen)} className=" text-white bg-black rounded-full mr-4 px-4 py-2 text-2xl">
              Apply
            </button>
          </div>
          {landmarklist.map((option) => (
            <div
              key={option.id}
              className="ml-4 px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => handleOptionClick(option.id)}
            >
              <input
                type="checkbox"
                className="mr-2 cursor-pointer accent-black"
                checked={selectedOptions.includes(option.id)}
                onChange={() => handleOptionClick(option.id)}
              />
              <span className="select-none text-2xl">{option.title}</span>
            </div>
          ))}
          
        </div>
        
        </>
        
      )}
    </div>
  );
}

export default LandMarkDropdown;
